'use client'

import { QUERY_ROUTES } from '@/core/constants/routes'
import { useDeleteSearchParam } from '@/core/hooks/use-delete-search-params'
import { Modal, ModalBody } from '@/core/ui/atoms/modal'
import { useCallback } from 'react'
import { VerifyPhone } from './verify-phone'

export const CustomerVerifyPhoneModal = () => {
  const { searchParams, deleteSearchParam } = useDeleteSearchParam()

  const handleClose = useCallback(() => {
    deleteSearchParam(QUERY_ROUTES.verifyPhone.name, {
      clientOnly: true,
    })
  }, [deleteSearchParam])

  return (
    <Modal
      className='w-96'
      isOpen={
        QUERY_ROUTES.verifyPhone.value ===
        searchParams.get(QUERY_ROUTES.verifyPhone.name)
      }
      onClose={handleClose}
      hideCloseButton
      disableBackdropDismiss
    >
      <ModalBody className='p-6'>
        <VerifyPhone onClose={handleClose} />
      </ModalBody>
    </Modal>
  )
}
